export default class Storage {
    static KEYS = {
        USERTOKEN: "userToken",
        USERDATA: "userData",
        ORGANIZATION_DATA: "organizationData",
        ORGANIZATIONS: "organizations",
        CLI_LOGIN_PARAMS: "cliLoginParams",
        USER_DOCUMENTATION_NAME: "userDocumentationName",
        USER_DOCUMENTATION: "userDocumentation",
        CREDENTIAL_LOGIN_TYPE: "credentialLoginType"
    };

    static set(index, value) {
        localStorage.setItem(index, value);
    }

    static get(index) {
        return localStorage.getItem(index);
    }

    static remove(index) {
        localStorage.removeItem(index);
    }

    static clearAll() {
        localStorage.clear();
    }

    static setInSession(key = "", value = "") {
        sessionStorage.setItem(key, value);
    }

    static getInSession(key = "") {
        return sessionStorage.getItem(key);
    }

    static clearInSession() {
        sessionStorage.clear();
    }
}
